import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { FilterTypesEnum } from "src/app/models/filters/filterTypes.enum";
import { IPageFilters } from "src/app/models/filters/interfaces/pageFilters.interface";
import { ISelectOption } from "src/app/models/selectOptions";
import { ActiveFiltersHeightService } from "src/app/services/infra/activeFiltersHeight/active-filters-height.service";

@Component({
    selector: "app-view-filters-multi-select",
    templateUrl: "./view-filters-multi-select.component.html",
    styleUrls: ["./view-filters-multi-select.component.scss"],
})
export class ViewFiltersMultiSelectComponent implements OnInit, AfterViewChecked, OnDestroy {
    @Input() public pageFilters: IPageFilters;

    public selectedOptions: ISelectOption[] = [];
    private _previousHeight = 0;

    constructor(
        private _el: ElementRef,
        private _activeFiltersHeightService: ActiveFiltersHeightService,
    ) {}

    ngOnInit(): void {
        this.pageFilters.onUpdate$.subscribe(() => {
            this.selectedOptions = this.pageFilters.getAllSelectedOptions();
        });
    }

    ngAfterViewChecked() {
        this._handleAppliedFiltersBlockHeight();
    }

    ngOnDestroy() {
        this._activeFiltersHeightService.updateHeight(0);
    }

    public tablesFiltersChange(selectedOptions: ISelectOption[]) {
        this.pageFilters.updateFilterFromUserSelection(undefined, selectedOptions);
    }

    public fromDateSelected(value?: Date): void {
        this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
    }

    public toDateSelected(value?: Date): void {
        this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
    }

    public searchSubmitted(value?: string): void {
        this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
    }

    public clearSelectedFilters() {
        this.pageFilters.updateFiltersByKeyValue({}, true);
    }

    public clearSingleOption(optionToRemove: ISelectOption) {
        this.pageFilters.removeSelectedOptionsIfExist([optionToRemove]);
    }

    private _handleAppliedFiltersBlockHeight() {
        const newHeight = this._el.nativeElement.offsetHeight;

        if (newHeight !== this._previousHeight) {
            this._previousHeight = newHeight;
            this._activeFiltersHeightService.updateHeight(newHeight);
        }
    }
}
